// Gsap Animation Top Page
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.getElementById("circle");
  if (!wrapper) {
    console.warn("Element with ID 'circle' not found.");
    return;
  }

  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const totalItems = isMobile ? 40 : 27;

  const randomAngles = [];
  for (let i = 0; i < totalItems; i++) {
    const item = document.createElement("div");
    item.className =
      "slide-item absolute top-[50%] left-[50%] transform-[translate(-50%, -50%)] md:w-[190px] w-[calc(97/390*100vw)] md:h-[190px] h-[calc(97/390*100vw)]";

    const img = document.createElement("img");
    img.src = conceptImages[i % conceptImages.length];
    item.appendChild(img);

    wrapper.appendChild(item);

    randomAngles.push(Math.random() * 360);
  }

  const items = wrapper.querySelectorAll(".slide-item");

  function calculateRadius() {
    return isMobile ? window.innerWidth * 1.731 : 900;
  }

  function updatePositions() {
    const radius = calculateRadius();
    const total = items.length;

    items.forEach((item, index) => {
      const angle = (360 / total) * index;
      const radians = angle * (Math.PI / 180);
      const x = Math.cos(radians) * radius;
      const y = Math.sin(radians) * radius;

      item.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px) rotate(${angle + randomAngles[index]}deg)`;
    });
  }

  updatePositions();

  window.addEventListener("resize", updatePositions);

  gsap.to(wrapper, {
    rotate: 360,
    duration: 240,
    repeat: -1,
    ease: "linear",
    transformOrigin: "50% 50%",
  });
});

// AJAX Load more blog
document.addEventListener("DOMContentLoaded", function () {
  const loadMoreContainer = document.getElementById("load-more");
  if (!loadMoreContainer) return;

  const loadMoreLink = loadMoreContainer.querySelector("a");
  if (!loadMoreLink) return;

  loadMoreLink.addEventListener("click", function (event) {
    event.preventDefault();

    const nextUrl = loadMoreLink.getAttribute("href");
    if (!nextUrl) return;

    fetch(nextUrl)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const newArticles = doc.querySelectorAll(".article-item");

        const articleContainer = document.querySelector(".blog-articles");
        newArticles.forEach((article) => {
          articleContainer.appendChild(article);
        });

        const newLoadMore = doc.getElementById("load-more");
        if (newLoadMore) {
          loadMoreContainer.innerHTML = newLoadMore.innerHTML;
        } else {
          loadMoreContainer.remove();
        }
      })
      .catch((error) => {
        console.error("その他の記事の読み込み中にエラーが発生しました:", error);
      });
  });
});

// Setting to cart
document.addEventListener("DOMContentLoaded", () => {
  // Helper function to update quantity and price
  function updateQuantityAndPrice(svgElement, change) {
    const quantityElement = svgElement
      .closest(".cart-item")
      .querySelector(".quantity");
    let currentQuantity = parseInt(quantityElement.textContent);

    const unitPrice = parseFloat(svgElement.dataset.price || "0");
    if (!unitPrice || isNaN(unitPrice)) {
      console.warn("SVG の data-price 属性が欠落しているか無効です");
      return;
    }

    // Update the quantity
    // currentQuantity += change;

    // // Ensure quantity does not go below 1
    // if (currentQuantity < 1) return;

    let newQuantity = currentQuantity + change;

    // // Ensure quantity does not go below 1 to 12
    // if (newQuantity < 1) return;

    // if (newQuantity > 12) {
    //   alert("各商品につき、最大数量は12個です！");
    //   return;
    // }

    quantityElement.textContent = newQuantity;

    // Update line price for the item
    const priceElement = svgElement
      .closest(".cart-item")
      .querySelector(".line-price");
    if (priceElement) {
      const newLinePrice = unitPrice * newQuantity;
      priceElement.textContent = `¥${newLinePrice.toLocaleString("ja-JP")}`;
    }

    // Update cart in Shopify
    const itemKey = svgElement.dataset.itemKey;
    updateCartQuantity(itemKey, newQuantity);

    updateTotalPrice();
    updateCartIconQuantity();
  }

  // Decrease Quantity
  window.decreaseQuantity = function (svgElement) {
    updateQuantityAndPrice(svgElement, -1);
  };

  // Increase Quantity
  window.increaseQuantity = function (svgElement) {
    updateQuantityAndPrice(svgElement, 1);
  };

  // Function to update cart quantity in Shopify
  function updateCartQuantity(itemKey, newQuantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemKey, // itemKey of the product in the cart
        quantity: newQuantity, // new quantity
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Optionally update the cart UI here if needed
        console.log("カートを更新しました:", data);
      })
      .catch((error) => {
        console.error("カートの更新中にエラーが発生しました:", error);
      });
  }

  function updateTotalPrice() {
    let totalPrice = 0;

    // Loop through each cart item
    const cartItems = document.querySelectorAll(".cart-item");
    cartItems.forEach((item) => {
      const quantity = parseInt(item.querySelector(".quantity").textContent);
      const linePriceElement = item.querySelector(".line-price");

      if (!linePriceElement) return;

      const linePrice = linePriceElement.textContent;

      // Clean the price string, removing all non-numeric characters except for the dot
      const unitPrice = parseFloat(linePrice.replace(/[^\d.-]/g, ""));

      if (!isNaN(unitPrice) && !isNaN(quantity)) {
        totalPrice += unitPrice; // Add the price to the total
      }
    });

    // Update the total price display
    const totalElement = document.querySelector(".cart-total");
    if (totalElement) {
      totalElement.textContent = `¥${totalPrice.toLocaleString("ja-JP")}`; // Format the total
    }
  }

  // Function to update the quantity in the cart icon
  function updateCartIconQuantity() {
    const cartIconCount = document.querySelector(".cart-icon-count");
    const totalQuantity = Array.from(
      document.querySelectorAll(".cart-item"),
    ).reduce((total, item) => {
      const quantity = parseInt(item.querySelector(".quantity").textContent);
      return total + (isNaN(quantity) ? 0 : quantity);
    }, 0);

    // If there are items in the cart, update the count
    if (cartIconCount) {
      if (totalQuantity > 0) {
        cartIconCount.textContent = totalQuantity;
        cartIconCount.classList.remove("hidden");
      } else {
        cartIconCount.textContent = "";
        cartIconCount.classList.add("hidden");
      }
    }
  }

  const removeButtons = document.querySelectorAll(".remove-item");

  removeButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const itemKey = this.dataset.itemKey;
      removeProductFromCart(itemKey, this);
    });
  });

  function removeProductFromCart(itemKey, buttonElement) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("商品は削除されました:", data);

        removeItemFromDOM(buttonElement);
        checkCartEmpty();
        updateTotalPrice();
        updateCartIconQuantity();
      })
      .catch((error) => {
        console.error("商品の削除中にエラーが発生しました:", error);
      });
  }

  function removeItemFromDOM(buttonElement) {
    const itemWrapper = buttonElement.closest(".cart-item");

    if (itemWrapper) {
      itemWrapper.remove();
    }
  }

  function checkCartEmpty() {
    const cartItems = document.querySelectorAll(".cart-item");

    if (cartItems.length === 0) {
      const cartModal = document.querySelector(".cart-modal");
      const cartContainer = document.querySelector(".cart-container");
      cartContainer.remove();

      const emptyMessage = document.createElement("h3");
      emptyMessage.textContent =
        "カートに商品がありません。商品を選択してください。";
      emptyMessage.classList.add(
        "empty-cart-message",
        "justify-start",
        "font-Zen_Kaku_Gothic_New",
        "text-[calc(16/390*100vw)]",
        "font-bold",
        "text-zinc-800",
        "md:text-xl",
      );

      cartModal.appendChild(emptyMessage);

      const cartIcon = document.querySelector(".cart-icon");
      if (cartIcon) {
        cartIcon.classList.add("hidden");
      }
    }
  }
});

// Setting dateTimePicker
document.addEventListener("alpine:init", () => {
  Alpine.data("dateTimePicker", () => ({
    selectedDate: null,
    datepicker: null,
    timepicker: null,
    deliveryMode: "now",

    init() {
      this.datepicker = flatpickr(this.$refs.date, {
        dateFormat: "Y年n月j日",
        minDate: "today",
        disable: window.deliveryRules.blockedDates,
        locale: "ja",
        disableMobile: true,
        onChange: ([date]) => {
          this.selectedDate = date;
          this.setMinTimeBasedOnDate();
          this.timepicker.clear();
          this.$refs.time.value = "";
        },
      });

      this.timepicker = flatpickr(this.$refs.time, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        locale: "ja",
        defaultDate: null,
        allowInput: true,
        minuteIncrement: 5,
        disableMobile: true,
        onOpen: () => {
          this.setMinTimeBasedOnDate();
        },
      });

      this.$watch("deliveryMode", (val) => {
        if (val === "now") {
          this.selectedDate = null;
          if (this.datepicker) this.datepicker.clear();
          if (this.timepicker) this.timepicker.clear();
          this.$refs.date.value = "";
          this.$refs.time.value = "";
        }
      });
    },

    setMinTimeBasedOnDate() {
      if (!this.selectedDate || !this.timepicker) return;

      const now = new Date();
      const isToday = this.selectedDate.toDateString() === now.toDateString();

      let minTime;
      let defaultHour = null;
      let defaultMinute = null;

      if (isToday) {
        now.setHours(now.getHours() + 1);
        now.setSeconds(0);
        now.setMilliseconds(0);

        minTime = `${now.getHours().toString().padStart(2, "0")}:${now
          .getMinutes()
          .toString()
          .padStart(2, "0")}`;

        defaultHour = now.getHours();
        defaultMinute = now.getMinutes();
      } else {
        minTime = "10:00";
        defaultHour = 10;
        defaultMinute = 0;
      }

      this.timepicker.set({
        minTime: minTime,
        maxTime: "18:00",
        defaultDate: null,
        defaultHour: defaultHour,
        defaultMinute: defaultMinute,
      });

      this.timepicker.clear();
      this.$refs.time.value = "";
    },
  }));
});

// Setting delivery time to order
document
  .querySelector("#checkout-button")
  ?.addEventListener("click", function (e) {
    e.preventDefault();

    const mode = document.querySelector(
      'input[name="delivery-mode"]:checked',
    )?.value;
    const receipt = document.querySelector(
      'input[name="receipt"]:checked',
    )?.value;
    const date = document.querySelector("#delivery-date")?.value;
    const time = document.querySelector("#delivery-time")?.value;
    const recipient_name = document.querySelector("#recipient-name")?.value;
    const note = document.querySelector("#custom-request")?.value;

    if (!window.deliveryRules.canCheckout(mode, date)) {
      alert("選択された日は配送できません。別の日付を選択してください。");
      return;
    }

    if (mode === "schedule" && (!date || !time)) {
      alert("配達日・時間を指定する場合、日付と時間の両方を選択してください。");
      return;
    }

    if (receipt === "required" && !recipient_name) {
      alert("宛先氏名を入力してください。");
      return;
    }

    const attributes = {
      宛先: receipt === "required" ? recipient_name : "",
      配達モード: mode === "now" ? "今すぐ" : "配達日時を指定",
      配達日: mode === "now" ? "" : date,
      配達時間: mode === "now" ? "" : time,
    };

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes,
        note: note || "",
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("配送情報を保存できませんでした。");
        return res.json();
      })
      .then(() => {
        window.location.href = "/checkout";
      })
      .catch((err) => {
        console.error("カート属性の更新時にエラーが発生しました:", err);
        alert(
          "配送情報の保存中にエラーが発生しました。もう一度お試しください。",
        );
      });
  });
